import { render, staticRenderFns } from "./TagHeader.vue?vue&type=template&id=7a2f7e4b&scoped=true"
import script from "./TagHeader.vue?vue&type=script&lang=js"
export * from "./TagHeader.vue?vue&type=script&lang=js"
import style0 from "./TagHeader.vue?vue&type=style&index=0&id=7a2f7e4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2f7e4b",
  null
  
)

export default component.exports